import { makeStyles } from 'tss-react/mui';
import { StarsIcon } from '../icons/StarsIcon';

const useStyles = makeStyles()(() => ({
  fab: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #CF6880 0%, #9276CD 100%)',
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(146, 118, 205, 0.4)',
    cursor: 'default',
    zIndex: 1300,
    border: 'none',
    color: '#FFFFFF',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: '0 6px 16px rgba(146, 118, 205, 0.5)',
    },
  },
}));

export const FAB = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.fab} role="presentation" aria-hidden="true">
      <StarsIcon fontSize="medium" />
    </div>
  );
};
